export const START_PUBLIC_EVALUATION = 'START_PUBLIC_EVALUATION'
export const LOAD_PUBLIC_EVALUATION = 'LOAD_PUBLIC_EVALUATION'
export const LOAD_PERSONALIZED_EVALUATION = 'LOAD_PERSONALIZED_EVALUATION'
export const PRELOAD_PUBLIC_EVALUATION = 'PRELOAD_PUBLIC_EVALUATION'
export const EVALUATE_PUBLIC_EVALUATION = 'EVALUATE_PUBLIC_EVALUATION'
export const EXTEND_MACROTREND = 'EXTEND_MACROTREND'
export const CHECK_EVALUATION_PARTICIPANT_VALID = 'CHECK_EVALUATION_PARTICIPANT_VALID'
export const PUBLIC_EVALUATION_SEND_FEEDBACK = 'PUBLIC_EVALUATION_SEND_FEEDBACK'
